import Vue from 'vue'

import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'

//// TODO: REMOVE THIS VERSION! XSS vulnerability in plugin.

Vue.use(MarkdownItVue)